var React = require('react');

function IconCI (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M859.148 477.801c0-186.119-137.542-340.114-316.526-365.885v103.829c122.185 24.648 214.189 132.608 214.189 262.057 0 90.257-44.728 170.068-113.226 218.476l-45.756-88.773-72.48 225.42 201.51 24.916-36.051-69.945c101.334-65.932 168.34-180.189 168.34-310.095zM173.687 205.752c0 51.888 130.212 94.252 293.897 96.802V108.95c-163.684 2.549-293.897 44.914-293.897 96.802zm293.898 146.863c-152.682-2.288-293.897-49.94-293.897-49.94v118.81s145.678 48.296 293.897 49.98v-118.85zm0 187.593c-152.682-2.289-293.897-49.94-293.897-49.94v118.81s145.678 48.296 293.897 49.98v-118.85zM173.687 677.863v118.81s145.678 48.296 293.897 49.98V727.802c-152.681-2.288-293.897-49.939-293.897-49.939z"}));
}

IconCI.displayName = "IconCI";

IconCI.defaultProps = {"viewBox":"15.167 -16.333 1000.636 1000.678"};

module.exports = IconCI;

IconCI.default = IconCI;
